// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import PropTypes from 'prop-types'
import { Navigate } from 'react-router'
import { Heading, Box, Button, Input, Text } from 'theme-ui'
import StaticLayout from './lander-layout'
import { useState } from 'react'

import { useAuth } from 'react-oidc-context'

const SignIn = ({ authed }) => {
  const auth = useAuth()
  const [showCodePopup, setShowCodePopup] = useState(true)
  const [codeInput, setCodeInput] = useState('')
  const [codeError, setCodeError] = useState('')
  const [isInputFocused, setIsInputFocused] = useState(false)

  const handleCodeSubmit = (e) => {
    e.preventDefault()
    if (codeInput.toLowerCase() === 'polisdk') {
      setShowCodePopup(false)
      setCodeError('')
    } else {
      setCodeError('Forkert kode. Prøv igen.')
      setCodeInput('')
    }
  }

  const drawCodePopup = () => {
    if (!showCodePopup) return null

    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
        <Box
          as="form"
          onSubmit={handleCodeSubmit}
          sx={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: 4,
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center'
          }}>
          <Heading as="h2" sx={{ mb: 3, color: 'primary', fontSize: 3 }}>
            Indtast adgangskode
          </Heading>
          <Text sx={{ mb: 3, color: 'mediumGray', fontSize: 1 }}>
            Du skal indtaste den udleverede adgangskode for oprette din bruger eller logge ind.
          </Text>
          <Input
            type="password"
            value={codeInput}
            onChange={(e) => setCodeInput(e.target.value)}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            placeholder={isInputFocused || codeInput ? '' : 'Indtast kode'}
            autoFocus
            sx={{
              mt: '1rem',
              mb: 2,
              border: '2px solid',
              borderColor: codeError ? 'red' : 'secondary',
              borderRadius: '8px',
              padding: 3,
              fontSize: 2,
              textAlign: 'center',
              '&:focus': {
                borderColor: 'primary',
                outline: 'none'
              }
            }}
          />
          {codeError && (
            <Text sx={{ color: 'red', fontSize: 1, mb: 2 }}>
              {codeError}
            </Text>
          )}
          <Button
            type="submit"
            sx={{
              backgroundColor: 'primary',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: 3,
              fontSize: 2,
              fontWeight: 'bold',
              cursor: 'pointer',
              width: '100%',
              '&:hover': {
                backgroundColor: '#5a4db8'
              }
            }}>
            Bekræft
          </Button>
        </Box>
      </Box>
    )
  }

  const drawLoginForm = () => {
    return (
      <Box>
        <Button
          sx={{ my: [2] }}
          id="signinButton"
          onClick={() =>
            auth.signinRedirect({
              state: { returnTo: window.location.pathname }
            })
          }>
          Log ind
        </Button>
      </Box>
    )
  }

  if (authed) {
    return <Navigate to={'/'} />
  }

  return (
    <StaticLayout>
      {drawCodePopup()}
      <Box sx={{ filter: showCodePopup ? 'blur(5px)' : 'none', pointerEvents: showCodePopup ? 'none' : 'auto' }}>
        <Heading as="h1" sx={{ my: [4, null, 5], fontSize: [6, null, 7] }}>
          Log ind
        </Heading>
        {drawLoginForm()}
      </Box>
    </StaticLayout>
  )
}

SignIn.propTypes = {
  authed: PropTypes.bool
}

export default SignIn
